import React from "react";
import { useNavigate } from "react-router-dom";
import { FileTextOutlined, CheckCircleOutlined, FileDoneOutlined } from "@ant-design/icons";
import Theme from "../../theme/Theme";
import { usePermissions } from "../../hooks/usePermissions";

function QuickActions() {
  const navigate = useNavigate();
  const { hasPlanApprovalPermission, hasTargetApprovalPermission } = usePermissions();

  const actions = [
    {
      title: "Update Target",
      icon: <FileTextOutlined />,
      path: "/my-plans",
      always: true,
    },
    {
      title: "Plan Approval",
      icon: <CheckCircleOutlined />,
      path: "/settings/plan-approvals",
      always: false,
      visible: hasPlanApprovalPermission,
    },
    {
      title: "Target Approval",
      icon: <FileDoneOutlined />,
      path: "/settings/target-approvals",
      always: false,
      visible: hasTargetApprovalPermission,
    },
  ].filter(a => a.always || a.visible);

  if (actions.length === 0) return null;

  return (
    <div
      className="mb-8 p-6 rounded-lg"
      style={{ backgroundColor: "white" }}
    >
      <div
        className="text-lg font-semibold mb-4"
        style={{ color: Theme().textPrimary, fontFamily: "Inter, sans-serif" }}
      >
        Quick Actions
      </div>
      <div className={`grid grid-cols-${actions.length} gap-4`}>
        {actions.map((action, index) => (
          <div
            key={index}
            onClick={() => navigate(action.path)}
            className="cursor-pointer p-4 rounded-lg text-center hover:shadow-md transition-shadow"
            style={{
              backgroundColor: Theme().attentionLight,
              border: `1px solid ${Theme().navBorder}`,
            }}
          >
            <div className="text-2xl mb-2" style={{ color: Theme().primary }}>
              {action.icon}
            </div>
            <div
              className="text-sm"
              style={{
                color: Theme().textPrimary,
                fontFamily: "Inter, sans-serif",
                fontWeight: 400,
              }}
            >
              {action.title}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default QuickActions;
